<template>
    <span>
        <b-button
            class="align-baseline mr-1"
            title="Edit"
            variant="default"
            @click="handleEditVariable"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalId"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalId"
            title="Delete Variable"
            @shown="onModalShown"
            @ok="handleDeleteVariable"
        >
            <b-row>
                <b-col>
                    Variable "{{ customVariableName }}" will be deleted. Are you sure?
                </b-col>
            </b-row>
        </modal>
    </span>    
</template>

<script>
    import { mapGetters } from 'vuex';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                customVariableId: 0,
                customVariableName: '',
                deleteModalId: '',
            };
        },
        created() {
            this.customVariableId = this.params.data.id;
            this.customVariableName = this.params.data.name;
            this.deleteModalId = `modal-delete-custom-variable-property-${this.customVariableId}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleDeleteVariable() {
                this.params.delete && this.params.delete(this.params.data, this.values);
            },
            handleEditVariable() {
                this.params.update && this.params.update(this.params.data);
            },
        },
    }
</script>
